<div class="errorDiv">
  <div class="warning-con">
    <kin-icon
      class="warning-icon"
      color="black"
      name="warning"
      [size]="128"
      [relativeSize]="true" />
  </div>

  <h1>Oops...</h1>

  <p>{{ errorMsg() }}</p>
</div>
